__turbopack_context__.v({
  "CreatorItem": "top-creators-module__v89u-G__CreatorItem",
  "CreatorList": "top-creators-module__v89u-G__CreatorList",
  "CreatorName": "top-creators-module__v89u-G__CreatorName",
  "Ranking": "top-creators-module__v89u-G__Ranking",
  "Revenue": "top-creators-module__v89u-G__Revenue",
});
